/**
 * @since 0.23.0
 * @visibleName LOG_LEVELS
 * @component
 */
export default {
  DEBUG: 'debug',
  INFO: 'info',
  LOG: 'log',
  WARN: 'warn',
  ERROR: 'error',
} as const;
